/**
 * Server-safe column ids + table display defaults for DEFAULT_USER_DISPLAY_PREFERENCES.
 * Keep in sync with ./columns.tsx.
 */

export const cdc_column_display_seeds: {
    id: string;
    defaultDisplayPreferences: {
        order: number;
        size: number;
        visible: boolean;
        pinned: boolean;
        displayAs: "number" | "string" | "date" | "other";
    };
}[] = [
    {
        id: "number",
        defaultDisplayPreferences: {
order: 0, visible: true, size: 80, pinned: true, displayAs: "string",
        },
    },
    {
        id: "status",
        defaultDisplayPreferences: {
order: 1, visible: true, size: 120, pinned: false, displayAs: "string"
        },
    },
    {
        id: "teacher",
        defaultDisplayPreferences: {
order: 2, visible: true, size: 200, pinned: false, displayAs: "string"
        },
    },
    {
        id: "teacherStatus",
        defaultDisplayPreferences: {
order: 3, visible: true, size: 150, pinned: false, displayAs: "string"
        },
    },
    {
        id: "startDate",
        defaultDisplayPreferences: {
order: 4, visible: true, size: 120, pinned: false, displayAs: "date"
        },
    },
    {
        id: "endDate",
        defaultDisplayPreferences: {
order: 5, visible: true, size: 120, pinned: false, displayAs: "date"
        },
    },
    {
        id: "faculty",
        defaultDisplayPreferences: {
order: 6, visible: true, size: 150, pinned: false, displayAs: "string"
        },
    },
    {
        id: "eventTypes",
        defaultDisplayPreferences: {
order: 7, visible: true, size: 200, pinned: false, displayAs: "string"
        },
    },
    {
        id: "attendancesCount",
        defaultDisplayPreferences: {
order: 8, visible: true, size: 100, pinned: false, displayAs: "number"
        },
    },
    {
        id: "workingMinutes",
        defaultDisplayPreferences: {
order: 9, visible: true, size: 100, pinned: false, displayAs: "string"
        },
    },
    {
        id: "attendancesCost",
        defaultDisplayPreferences: {
order: 10, visible: true, size: 100, pinned: false, displayAs: "string"
        },
    },
    {
        id: "author",
        defaultDisplayPreferences: {
order: 11, visible: true, size: 150, pinned: false, displayAs: "string"
        },
    },
    {
        id: "sentAt",
        defaultDisplayPreferences: {
order: 12, visible: true, size: 120, pinned: false, displayAs: "date"
        },
    },
    {
        id: "createdAt",
        defaultDisplayPreferences: {
order: 13, visible: true, size: 120, pinned: false, displayAs: "date"
        },
    },
    {
        id: "validatedAt",
        defaultDisplayPreferences: {
order: 14, visible: true, size: 120, pinned: false, displayAs: "date"
        },
    },
    {
        id: "validatedBy",
        defaultDisplayPreferences: {
order: 15, visible: true, size: 150, pinned: false, displayAs: "string"
        },
    },
    {
        id: "signedAt",
        defaultDisplayPreferences: {
order: 16, visible: true, size: 120, pinned: false, displayAs: "date"
        },
    },
    {
        id: "signedBy",
        defaultDisplayPreferences: {
order: 17, visible: true, size: 150, pinned: false, displayAs: "string"
        },
    },
    {
        id: "refusedAt",
        defaultDisplayPreferences: {
order: 18, visible: true, size: 120, pinned: false, displayAs: "date"
        },
    },
    {
        id: "refusedBy",
        defaultDisplayPreferences: {
order: 19, visible: true, size: 150, pinned: false, displayAs: "string"
        },
    },
];
